<script setup>
import { defineProps, defineEmits } from 'vue';

defineProps(['visibleVisitsType', 'visits']);
defineEmits(['getVisits'])
</script>

<template>
  <div class="visit-filter-buttons">
    <button
        type="button"
        class="tab-btn tab-btn-open"
        :class="{ active: visibleVisitsType === 'open' }"
        @click="$emit('getVisits', visits['open'].pagination.currentPage, 'open')"
    >
      Otwarte wizyty
    </button>
    <button
        type="button"
        class="tab-btn tab-btn-closed"
        :class="{ active: visibleVisitsType === 'closed' }"
        @click="$emit('getVisits', visits['closed'].pagination.currentPage, 'closed')"
    >
      Zamknięte wizyty
    </button>
    <button
        type="button"
        class="tab-btn tab-btn-closed"
        :class="{ active: visibleVisitsType === 'completed' }"
        @click="$emit('getVisits', visits['completed'].pagination.currentPage, 'completed')"
    >
      Zakończone wizyty
    </button>
    <button
        type="button"
        class="tab-btn tab-btn-closed"
        :class="{ active: visibleVisitsType === 'canceled' }"
        @click="$emit('getVisits', visits['canceled'].pagination.currentPage, 'canceled')"
    >
      Anulowane wizyty
    </button>
  </div>
</template>

<style scoped lang="scss">
.visit-filter-buttons {
  display: flex;
  gap: 12px;
}

.tab-btn {
  border: 1px solid #d1d5db;
  background: #fff;
  color: #1f2937;
  border-radius: 8px;
  padding: 10px 14px;
  cursor: pointer;
  font-size: 1.3rem;
  font-weight: 600;
  transition: all .15s ease;
}

.tab-btn-open.active {
  background: #f97316;
  color: #fff;
  border-color: #f97316;
}

.tab-btn-closed.active {
  background: #10b981;
  color: #fff;
  border-color: #10b981;
}

@media (max-width: 480px) {
  .visit-filter-buttons {
    flex-direction: column;
  }
}
</style>